import React, { Ref, useEffect, useRef, useState } from 'react';
import "./style.css"
import Spinner from '../spinner/spiner';

interface ModalProps {
    show: boolean;
    onClose?: () => void;
    onOpen?: () => void;
    handleConfirm?: () => void;
    title: string;
    textBtnCancelar?: string;
    textBtnConfirmar?: string;
    idModal?: string;
    coverMobile?: boolean;
    text?: string;
    isLoading?: boolean;
    errorMessage?: string;
    extraContent?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ idModal, show, onOpen, onClose, handleConfirm, title, text, isLoading, errorMessage, extraContent, textBtnCancelar, textBtnConfirmar, coverMobile = true }) => {
    const openModalRef = useRef<HTMLButtonElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        if (show){
            if(onOpen) onOpen();
            openModalRef.current?.click()
        }
        else
            closeModalRef.current?.click()
    }, [show])


    return (
        <>
            <div className="modal fade" id={idModal ? idModal : "confirmation-modal"} onClick={() => { if(onClose) onClose(); }} aria-hidden="true">
                <div className={`modal-dialog ${coverMobile ? "cover-mobile" : ""}`}>
                    <div id="username-suggestions"></div>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header" style={{ borderBottom: "0!important", paddingBottom: 0, }}>
                            <h5 className="modal-title" id="modal-post">{title}</h5>
                            <button ref={closeModalRef} type="button" className="btn-close svg-icons-color btn-dark" onClick={() => { if(onClose) onClose(); }} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>{text}</p>
                           
                            {extraContent}
                            <div className="invalid-feedback invalid-feedback-comment-text" style={{ display: "block" }}>
                                {errorMessage}
                            </div>

                            <div className="modal-footer mt-4" style={{ padding: "0" }}>
                                {textBtnCancelar && (
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={idModal ? `#${idModal}` : "#confirmation-modal"} onClick={() => {if(onClose) onClose();}}>{textBtnCancelar}</button>
                                )}

                                <button disabled={isLoading} type="button" className="btn btn-blue" onClick={handleConfirm} ref={openModalRef}>
                                    {!isLoading ? (
                                        <>{textBtnConfirmar ? textBtnConfirmar : "Confirmar"}</>
                                    ) : (
                                        <Spinner className='spinner-modal'/>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button className="d-none" ref={openModalRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={idModal ? `#${idModal}` : "#confirmation-modal"}>a</button>
        </>
    );
};

export default Modal;
